export const timeZonesTheme = {
  // Time of day colors
  '--tz-night-color': '#312e81',
  '--tz-morning-color': '#fbbf24',
  '--tz-afternoon-color': '#f59e0b',
  '--tz-evening-color': '#7c3aed',
  
  // Status colors
  '--tz-ahead-color': '#059669',
  '--tz-behind-color': '#dc2626',
  
  // Day indicator colors
  '--tz-next-day-bg': '#dbeafe',
  '--tz-next-day-text': '#1e40af',
  '--tz-prev-day-bg': '#fee2e2',
  '--tz-prev-day-text': '#b91c1c',
  
  // Time badge colors
  '--tz-day-badge-bg': '#fef3c7',
  '--tz-day-badge-text': '#92400e',
  '--tz-night-badge-bg': '#e0e7ff',
  '--tz-night-badge-text': '#4338ca',
}; 